function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "date-line",
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M25.045,6H22.569V7.524h2.285v16.76H3.524V7.524H5.809V6H3.333A1.356,1.356,0,0,0,2,7.379v17.05a1.356,1.356,0,0,0,1.333,1.379H25.045a1.356,1.356,0,0,0,1.333-1.379V7.379A1.356,1.356,0,0,0,25.045,6Z",
  transform: "translate(0 -0.953)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M8,14H9.524v1.524H8Z",
  transform: "translate(-1.429 -2.858)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M14,14h1.524v1.524H14Z",
  transform: "translate(-2.858 -2.858)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M20,14h1.524v1.524H20Z",
  transform: "translate(-4.287 -2.858)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M26,14h1.524v1.524H26Z",
  transform: "translate(-5.716 -2.858)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M8,19H9.524v1.524H8Z",
  transform: "translate(-1.429 -4.049)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M14,19h1.524v1.524H14Z",
  transform: "translate(-2.858 -4.049)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M20,19h1.524v1.524H20Z",
  transform: "translate(-4.287 -4.049)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M26,19h1.524v1.524H26Z",
  transform: "translate(-5.716 -4.049)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M8,24H9.524v1.524H8Z",
  transform: "translate(-1.429 -5.24)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_163",
  "data-name": "Path 163",
  d: "M14,24h1.524v1.524H14Z",
  transform: "translate(-2.858 -5.24)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M20,24h1.524v1.524H20Z",
  transform: "translate(-4.287 -5.24)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M26,24h1.524v1.524H26Z",
  transform: "translate(-5.716 -5.24)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M9.762,8.095a.762.762,0,0,0,.762-.762V2.762A.762.762,0,0,0,9,2.762V7.333A.762.762,0,0,0,9.762,8.095Z",
  transform: "translate(-1.667)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M25.762,8.095a.762.762,0,0,0,.762-.762V2.762a.762.762,0,1,0-1.524,0V7.333A.762.762,0,0,0,25.762,8.095Z",
  transform: "translate(-5.478)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M13,6h7.618V7.524H13Z",
  transform: "translate(-2.62 -0.953)",
  fill: "#ff0"
}));

var SvgCalendarYellow = function SvgCalendarYellow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.379,
    height: 22.855,
    viewBox: "0 0 24.379 22.855",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-yellow.bd355a22.svg";
export { ForwardRef as ReactComponent };